import React, { useCallback, useEffect, useState } from 'react';
import { Header, Footer } from '../../components';
import { Container, Content } from './styles';

interface IProps {
  showAction?: boolean;
  children: JSX.Element;
  onLearnMore?: () => void;
}

const DEFAULT_HEADER_HEIGHT = 80;

const PageHOC: React.FC<IProps> = ({ showAction = false, children, onLearnMore }) => {
  const [headerHeight, setHeaderHeight] = useState(DEFAULT_HEADER_HEIGHT);

  useEffect(() => {
    window.scroll({ top: 0, left: 0, behavior: 'smooth' });
  }, []);

  const handleHeaderHeightChange = useCallback((height: number) => {
    setHeaderHeight(height);
  }, []);

  return (
    <Container>
      <Header
        showAction={showAction}
        onLearnMore={onLearnMore}
        onHeightChange={handleHeaderHeightChange}
      />
      <Content $headerHeight={headerHeight}>{children}</Content>
      <Footer />
    </Container>
  );
};

export { PageHOC };
